import { Redirect, Route, Switch } from "react-router";
import { RedirectToDefaultPageOnAuthorized } from "../../../components/redirectOnAuthorized";
import { AppRouteUi } from "../../../config/appRoute";
import { PageAuthForgotPassword } from "./pageAuthForgotPassword";
import { PageAuthLogin } from "./pageAuthLogin";
import { PageAuthResetPassword } from "./pageAuthResetPassword";
import { PageAuthCompanyRegister } from "./pageAuthCompanyRegister";

const FallbackRoute = () => <Redirect to={AppRouteUi.Login.Root()} />;

export function PageAuth(): JSX.Element {
  return (
    <RedirectToDefaultPageOnAuthorized>
      <div className="d-flex justify-content-center align-items-center h-100">
        <Switch>
          <Route
            path={AppRouteUi.Login.Root()}
            exact
            component={PageAuthLogin}
          />
          <Route
            path={AppRouteUi.Login.ForgotPassword()}
            exact
            component={PageAuthForgotPassword}
          />
          <Route
            path={AppRouteUi.Login.ResetPassword()}
            exact
            component={PageAuthResetPassword}
          />
          <Route
            path={AppRouteUi.Login.RegisterCompany()}
            exact
            component={PageAuthCompanyRegister}
          />
          <Route path="**" component={FallbackRoute} />
        </Switch>
      </div>
    </RedirectToDefaultPageOnAuthorized>
  );
}
